var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenGiantDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.057 16.0688V12.9894H23.1V20.2702C22.3086 21.0182 21.1598 21.679 19.6536 22.2524C18.1559 22.8176 16.637 23.1002 15.0967 23.1002C13.1395 23.1002 11.4334 22.7013 9.97821 21.9034C8.52307 21.0972 7.42958 19.9502 6.69776 18.4625C6.45024 17.9565 6.24458 17.4357 6.08078 16.9003H2.80078V15.3003H5.72223C5.64076 14.7438 5.60002 14.173 5.60002 13.5879C5.60002 13.5251 5.60046 13.4626 5.60135 13.4003H2.80078V11.8003H5.7293C5.90846 10.6082 6.27383 9.51267 6.8254 8.51378C7.64232 7.03436 8.83792 5.89987 10.4122 5.11029C11.6121 4.50356 13.1055 4.2002 14.8925 4.2002C17.2156 4.2002 19.0282 4.6781 20.3301 5.6339C21.6406 6.5814 22.4831 7.89459 22.8575 9.57348L19.1048 10.2592C18.841 9.36154 18.3432 8.65508 17.6113 8.13977C16.888 7.61616 15.9817 7.35435 14.8925 7.35435C13.2416 7.35435 11.9269 7.8655 10.9483 8.88779C10.262 9.61108 9.8184 10.5819 9.61765 11.8003H13.3008V13.4003H9.49322C9.49318 13.4129 9.49316 13.4256 9.49316 13.4383C9.49316 14.1109 9.54061 14.7315 9.63552 15.3003H13.3008V16.9003H10.0831C10.3129 17.4488 10.6098 17.9238 10.9738 18.3253C11.9609 19.4058 13.2544 19.946 14.8542 19.946C15.6456 19.946 16.437 19.7964 17.2284 19.4972C18.0283 19.1897 18.7133 18.8199 19.2835 18.3877V16.0688H17.057Z",
    fill: "#45B549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGiantDollarIcon);
export default __webpack_public_path__ + "static/media/GreenGiantDollarIcon.c358d6e9af9360d291f4943014bb0421.svg";
export { ForwardRef as ReactComponent };